import React from 'react';
import rlogo from '../images/logo512.png'

function RLogo () {
    return (
        <div className='App'>
            <img src={rlogo} alt='logo' />
        </div>
    );
}

export default RLogo;